import { Component, ContentChildren, Input, QueryList } from "@angular/core";
import { PageDatagridToolbarActionComponent } from "./page-datagrid-toolbar-action.component";
import { PageDatagridToolbarSelectComponent } from "src/app/components/ui/page/page-datagrid/page-datagrid-toolbar-select.component";
import { PageDatagridToolbarTextComponent } from "src/app/components/ui/page/page-datagrid/page-datagrid-toolbar-text.component";

@Component({
  selector: "pms-page-datagrid-toolbar",
  template: "",
  standalone: false
})
export class PageDatagridToolbarComponent {
  @Input() message: string = "";

  @ContentChildren(PageDatagridToolbarActionComponent)
  actionItems!: QueryList<PageDatagridToolbarActionComponent>;

  @ContentChildren(PageDatagridToolbarSelectComponent)
  selectItems!: QueryList<PageDatagridToolbarSelectComponent>;

  @ContentChildren(PageDatagridToolbarTextComponent)
  textItems!: QueryList<PageDatagridToolbarTextComponent>;
}
